import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import { nameToUrl } from '../utils/url';
import formatDate from '../utils/date';

const ResultLink = ({
    courseName,
    courseUid,
    raceDatetime,
    raceDate,
    raceInstanceUid,
    raceInstanceTitle,
    children,
    className
}) => {
    if (!courseUid || !courseName || (!raceDatetime && !raceDate) || !raceInstanceUid) {
        return <span className={className}>—</span>;
    }

    const urlDate = formatDate(raceDatetime || raceDate, 'Y-MM-DD');
    const name = nameToUrl(courseName);
    const url = `/results/${courseUid}/${name}/${urlDate}/${raceInstanceUid}`;

    return (
        <a
            className={classNames('ui-link ui-link_table js-popupLink', className)}
            href={url}
            title={raceInstanceTitle}
        >
            { children || raceInstanceTitle }
            <Svg
                iconName="right"
                size="smallChevron"
            />
        </a>
    );
};

ResultLink.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceDate: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string
};

export default ResultLink;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/links/ResultLink.jsx